module.exports = __webpack_public_path__ + "img/hoogeland.d4913b9.svg";